<template>
<div
  class="row"
  v-if="!loadingAll"
>
  <div class="col-md-10 col-md-offset-1">

    <div class="card">
      <div class="card-header">
        <div class="card-title">Configurações do servidor</div>
      </div>
      <div class="card-content">
        <project-images></project-images>
      </div>
    </div>

    <RemoteConfigProject></RemoteConfigProject>
    <GeneralConfigProject></GeneralConfigProject>
    <CompanyInfoForm></CompanyInfoForm>
    <EventsConfigForm></EventsConfigForm>
    <RegisterConfigForm></RegisterConfigForm>
    <lamps-config-form></lamps-config-form>
    <TicketsConfigForm></TicketsConfigForm>

    <div
      class='text-right'
      style="margin-bottom: 30px;"
    >
      <button
        v-if="$can('project.edit|projectCreate')"
        :disabled="saving"
        type="submit"
        @click.prevent="handleSave"
        class="btn btn-fill btn-success btn-wd"
      ><i class="ti-save"></i> Salvar
      </button>
    </div>
  </div>
</div>

</template>
<script>
import TicketsConfigForm from '../../components/Trg/Project/TicketsConfigForm'
import LampsConfigForm from '../../components/Trg/Project/LampsConfigForm'
import EventsConfigForm from '../../components/Trg/Project/EventsConfigForm'
import CompanyInfoForm from '../../components/Trg/Project/CompanyInfoForm'
import GeneralConfigProject from '../../components/Trg/Project/GeneralConfigProject'
import RegisterConfigForm from '../../components/Trg/Project/RegisterConfigForm'
import RemoteConfigProject from '../../components/Trg/Project/RemoteConfigProject'
import CouchdbClass from 'src/services/CouchdbClass'
import { mapActions, mapGetters } from 'vuex'
import PSwitch from 'src/components/UIComponents/Switch.vue'
import ProjectImages from './ProjectImages'

export default {
  name: 'project-form',

  components: {
    PSwitch,
    TicketsConfigForm,
    ProjectImages,
    RemoteConfigProject,
    RegisterConfigForm,
    GeneralConfigProject,
    CompanyInfoForm,
    EventsConfigForm,
    LampsConfigForm
  },

  data () {
    return {
      loadingAll: true,
      indexPath: { name: 'project.index' },
      saving: false,
      model: {},

      company: {
        abbreviation: '',
        longname: '',
        cnpj: '',
        numberState: '',
        address: {
          type: '',
          street: '',
          number: '',
          complement: '',
          neighborhood: '',
          city: '',
          state: ''
        }
      },

      servername: '',
      name: '',
      eventLabel: '',
      requiredNIS: false,
      requiredTermLamp: false,
      defaultWinnerChoiceMode: 'lottery',
      haveSurveys: false,
      viewGoogleMap: false,
      eventHasCeremony: false,
      eventAutomaticReplacement: false,
      eventCustomersCanBeRecontemplated: false,
      eventContemplatedPeriod: 5,
      eventAutoDateOnDeliveryTerm: true,
      eventHasPhotos: false,
      eventManagedCsv: false,
      ticketAutomaticBarcode: true,
      lampsMax: 0,
      lampsNumLedLamps: 0,
      lampsHasSeason: false,
      lampsSeasonRange: 12,
      powerLampDeliveryLabel: '8,5W',
      validationCustomerUc: false,
      validationCustomerCpf: false,
      validationCustomerUcOrCpf: false,
      validationContemplatedCustomerUc: false,
      validationContemplatedCustomerCpf: false,
      currentState: '',
      cities: []
    }
  },

  computed: {
    project: {
      get () {
        return this.$store.state.project.one
      }
    },
    ...mapGetters('project', {
      modelValidations: 'validations',
      loading: 'loading',
      defaultWinnerChoiceModeOptions: 'defaultWinnerChoiceModeOptions'
    }),

    ...mapGetters('states', {
      statesOptions: 'statesOptions'
    }),

    stateCouchdb: function () {
      return new CouchdbClass({ connection: 'states' })
    },

    activeStateOptions: function () {
      return this.statesOptions.filter(item => {
        return Object.keys(this.termsByState).indexOf(item.value) >= 0
      })
    },

    termsByState: {
      get: function () {
        return this.$store.state.project.termsByState
      }
    },

    currentTerms: function () {
      return this.project.state && this.termsByState.hasOwnProperty(this.currentState) ? this.termsByState[this.currentState] : []
    },

    id () {
      return 'config'
    },
    editing () {
      return this.id !== undefined
    }
  },

  methods: {
    ...mapActions('project', [
      'fetchOne',
      'resetOne',
      'upsert'
    ]),
    ...mapActions('states', {
      fetchStates: 'fetchAll'
    }),
    ...mapActions(['setConfig']),

    getError (fieldName) {
      return this.errors.first(fieldName)
    },

    handleSave () {
      this.saving = true
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.runSave()
        }
      }).catch(err => {
        console.log(err)
        this.saving = false
      })
    },

    runSave () {
      this.upsert(Object.assign({ _id: 'config' }, this.project))
        .then(() => {
          this.$notify({
            message: 'Registro atualizado com sucesso.',
            type: 'success'
          })
          this.setConfig()
          this.fetchOne(this.id)
          this.$router.push(this.indexPath)
          this.saving = false
        })
        .catch(err => {
          console.log(err)
          this.saving = false
        })
    },

    getState () {
      return this.stateCouchdb.where('sigla', this.currentState).first()
    },

    async changeStateName () {
      const state = await this.getState()
      this.cities = state ? state.cidades : []
      this.company.address.state = state ? state.nome : ''
    }
  },
  filters: {
    number (value) {
      return value.replace(/\D+/g, '')
    }
  },

  mounted () {
    this.loadingAll = true
    // this.fetchOne('config')
    this.fetchStates({ limit: 999 })
    this.changeStateName()
    this.loadingAll = false
  }
}
</script>
<style>
  .select-primary.el-select .el-input .el-input__icon {
    height: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Project/ProjectForm.vue